import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=add83cb2&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=add83cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add83cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('add83cb2')) {
      api.createRecord('add83cb2', component.options)
    } else {
      api.reload('add83cb2', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=add83cb2&scoped=true&", function () {
      api.rerender('add83cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20POGN8p11L2j/JS/comp/PopupDialog.vue"
export default component.exports